import React, { createContext } from 'react';

export interface IAlert {
    message: string;
    status: string;
}

export const FeedbackContext = createContext(
    undefined as unknown as {
        addAlert: (alert: IAlert) => void;
        alerts: IAlert[];
        deleteAlert: (index: number) => void;
        removeAllAlert: () => void;
        positionToBottom: boolean;
        setPositionToBottom: (arg: boolean) => void;
    }
);
